// Sound on/off flag. v0.1 starts default-on each session — Step 14 wires a
// real settings UI and persists the choice (Dexie, not localStorage per
// CLAUDE.md). Until then, in-memory state is fine.

import { create } from 'zustand'

interface SoundStore {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
  toggle: () => void
}

export const useSoundStore = create<SoundStore>((set) => ({
  enabled: true,
  setEnabled: (enabled) => set({ enabled }),
  toggle: () => set((s) => ({ enabled: !s.enabled })),
}))
